import { CountUp } from 'countup.js';

export const monthRefs = [
  { abbr: "jan", no: 1, name: "January"},
  { abbr: "feb", no: 2, name: "February"},
  { abbr: "mar", no: 3, name: "March"},
  { abbr: "apr", no: 4, name: "April"},
  { abbr: "may", no: 5, name: "May"},
  { abbr: "jun", no: 6, name: "June"},
  { abbr: "jul", no: 7, name: "July"},
  { abbr: "aug", no: 8, name: "August"},
  { abbr: "sep", no: 9, name: "September"},
  { abbr: "oct", no: 10, name: "October"},
  { abbr: "nov", no: 11, name: "November"},
  { abbr: "dec", no: 12, name: "December"}
]

export const hospitals = [
  {
    name: "University College London Hospital (UCLH)",
    lat: 51.5250833,
    lng: -0.1363548
  },
  {
    name: "St Thomas’ Hospital",
    lat: 51.4990946,
    lng: -0.1188545
  },
  {
    name: "Guy’s Hospital",
    lat: 51.503109,
    lng: -0.0869631
  },
  {
    name: "The Royal London Hospital",
    lat: 51.5182221,
    lng: -0.0585176
  },
  {
    name: "The Nightingale, Excel",
    lat: 51.5084601,
    lng: 0.029846
  },
]

export function num1K1MFormatter (num, decPlaces = 0) {
  if (Math.abs(num) > 999999) {
    return Math.sign(num)*((Math.abs(num)/1000000).toFixed(decPlaces)) + 'M'
  }
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(decPlaces)) + 'K' : Math.sign(num)*Math.abs(num)
}

export function num1K1MParts (num, decPlaces = 0, decPlacesM = 0) {
  if (Math.abs(num) > 999999) {
    console.log("functionnum1K1MParts -> num", num, Math.sign(num)*((Math.abs(num)/1000000).toFixed(decPlacesM)))
    return { num: Math.sign(num)*((Math.abs(num)/1000000).toFixed(decPlacesM)), suffix: 'M' }
  }
  return Math.abs(num) > 999 ? { num: Math.sign(num)*((Math.abs(num)/1000).toFixed(decPlaces)), suffix: 'K' } : { num: Math.sign(num)*Math.abs(num).toFixed(decPlaces) }
}

export function arrayToObject (array, keyField) {
  array.reduce((obj, item) => {
    obj[item[keyField]] = item
    return obj
  }, {});
}

export function ioRevealInit (container) {
  // First we select the element we want to target
  const targets = container.querySelectorAll('.ioreveal');

  // Next we want to create a function that will be called when that element is intersected
  function handleIntersection (entries) {
    // The callback will return an array of entries, even if you are only observing a single item
    let countUpIndex = 0
    let countUpCompleted = {}
    entries.map((entry) => {
      if (entry.isIntersecting) {
        // console.log("handleIntersection -> entry", entry.target)
        const aniClass = entry.target.getAttribute('data-anicss')
        if (!entry.target.classList.contains(aniClass)) {
          entry.target.classList.add(aniClass)
        }
        const countUps = entry.target.querySelectorAll('[data-countup]')
        countUps.forEach((el) => {
          // console.log("handleIntersection -> el", el)
          // TODO: add check to see if el already had run the countup animation
          const options = { decimalPlaces: el.getAttribute('data-countup-decplaces') || 1 }
          countUpIndex++
          setTimeout(() => (new CountUp(el, el.getAttribute('data-countup'), options)).start(), 500*countUpIndex);
        })
      }
    });
  }

  // Next we instantiate the observer with the function we created above.
  // This takes an optional configuration object
  const observer = new IntersectionObserver(handleIntersection);

  // Finally start observing the target elements
  targets.forEach(function(target) {
    observer.observe(target);
  })

}

export function ioSectionsInit (sectionInViewRefObj) {
  const targets = document.querySelectorAll('section');
  const observer = new IntersectionObserver(entries => {
    let firstInView = false
    entries.map((entry, i) => {
      if (entry.isIntersecting) {
        let yPosition = entry.boundingClientRect.y
        // sectionInViewRefObj.target = entry.target
        if (!firstInView) {
          // sectionInViewRefObj.target = entry.target
          // if (entry.target === document.querySelector('section') && yPosition > 50 && yPosition < 500) { // if first section
          if (yPosition > 50 && yPosition < document.querySelector('section').offsetHeight) { // if first section
            sectionInViewRefObj.target = entry.target.nextElementSibling //.nextSibling.nextSibling
            // console.log(" ----- -> entry.target.nextElementSibling", entry.target, entry.target.nextElementSibling)
          } else if (entry.target === document.querySelector('section')) {
            sectionInViewRefObj.target = entry.target.nextElementSibling
          }
          // sectionInViewRefObj.no = entry
          // console.log("ioSectionsInit -> entry.target.nextSibling", entry.target.nextElementSibling)
          // console.log("ioSectionsInit -> sectionInViewRefObj.target", sectionInViewRefObj.target)
        }
        // firstInView = true
      }
      // console.log("****  ealInit -> entry", i, entry.boundingClientRect.y)
      // console.log("****  ealInit -> entry", i, entry.boundingClientRect.y, entry.target, document.querySelector('section'))
    });
  }, { threshold: [0.05] });
  targets.forEach(target => observer.observe(target));
}